import script from "./UserDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDropdown.vue?vue&type=script&setup=true&lang=js"

import "./UserDropdown.vue?vue&type=style&index=0&id=3732ae21&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3732ae21"]])

export default __exports__